import React from "react";
import {observer} from "mobx-react";
import Label, {LABEL_VARIANT} from "../../../../../../../../../../components/label/label";
import {ILocationLabelsGroup} from "../../../../../../../../stores/compare-value/location-compare-value-list-stores/location-labels-grouper";
import {ILocationToken} from "../../../../../../../../stores/compare-value/location-compare-value-list-stores/location-compare-value-store-list";

interface ICountryLabelsProps {
    countryLabelsGroup: ILocationLabelsGroup;
}

/**
 * Renders tag element for country with nested regions/cities.
 * Tokens contain human-readable names, not codes.
 */
const CountryLabels: React.FC<ICountryLabelsProps> = observer(({ countryLabelsGroup }: ICountryLabelsProps) => {
    return (
        <>

            <Label
                key={`country-${countryLabelsGroup.countryLabel}`}
                labelText={countryLabelsGroup.countryLabel}
                variant={LABEL_VARIANT.ACCENT}
            />

            {countryLabelsGroup.tokens.map((token: ILocationToken, index: number) => {

                /** Token with country, province, and city */
                if (token.province && token.city) {
                    return (
                        <Label
                            key={`city-${index}`}
                            labelText={token.city}
                            variant={LABEL_VARIANT.GRAY}
                        />
                    );
                }

                /** Token with country and province only */
                if (token.province) {
                    return (
                        <Label
                            key={`province-${index}`}
                            labelText={token.province}
                            variant={LABEL_VARIANT.ACCENT_LIGHT}
                        />
                    );
                }

                /** Token with country and city only (no province) */
                if (token.city) {
                    return (
                        <Label
                            key={`city-${index}`}
                            labelText={token.city}
                            variant={LABEL_VARIANT.GRAY}
                        />
                    );
                }

                /** Token with country only - already shown as country label, no additional tag needed */
                return null;
            })}
        </>
    );
});

export default CountryLabels;

